export default __webpack_public_path__ + "static/media/edit_icon.aebd50a8.svg";